var render = function render(){var _vm=this,_c=_vm._self._c;return _c('timeline-step',{ref:`step-${_vm.step.id}`,attrs:{"step":_vm.step,"dusk":`timeline-step-${_vm.step.id}`},on:{"toggleStep":function($event){return _vm.toggleStep(_vm.step.id)}}},[_c('div',{staticClass:"flex justify-center"},[_c('a',{staticClass:"button button-primary mt-4",attrs:{"href":"/campaigns"}},[_vm._v("Campaigns")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }